// GlobalTextArea.tsx
import React from 'react';
import { InputTextarea } from 'primereact/inputtextarea';

interface GlobalTextAreaProps {
  label?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  rows?: number;
  autoResize?: boolean;
  fullWidth?: boolean;
  maxLength?: number;
}

export const GlobalTextArea: React.FC<GlobalTextAreaProps> = ({
  label,
  value,
  onChange,
  placeholder = '',
  required = false,
  disabled = false,
  error = '',
  rows = 4,
  autoResize = true,
  fullWidth = true,
  maxLength,
}) => {
  return (
    <div style={{ width: fullWidth ? '100%' : 'auto' }}>
      {label && (
        <label style={{
          display: 'block',
          fontSize: '13px',
          fontWeight: 600,
          color: error ? '#ef4444' : '#1e3a8a',
          marginBottom: '8px'
        }}>
          {label} {required && <span style={{ color: '#ef4444' }}>*</span>}
        </label>
      )}
      
      <InputTextarea
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
        autoResize={autoResize}
        maxLength={maxLength}
        style={{
          width: '100%',
          padding: '12px 14px',
          border: `1px solid ${error ? '#ef4444' : '#e5e7eb'}`,
          borderRadius: '10px',
          fontSize: '14px',
          transition: 'all 0.2s ease',
          background: disabled ? '#f9fafb' : 'white',
          color: disabled ? '#9ca3af' : '#1f2937',
          minHeight: rows ? `${rows * 24 + 24}px` : '120px',
          resize: autoResize ? 'none' : 'vertical',
          fontFamily: 'inherit'
        }}
        className="global-textarea"
      />
      
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: '6px'
      }}>
        {error && (
          <span style={{
            fontSize: '12px',
            color: '#ef4444',
            fontWeight: 500
          }}>
            {error}
          </span>
        )}
        
        {maxLength && (
          <span style={{
            fontSize: '12px',
            color: value.length >= maxLength ? '#ef4444' : '#9ca3af',
            fontWeight: 500,
            marginLeft: 'auto'
          }}>
            {value.length}/{maxLength}
          </span>
        )}
      </div>

      <style>{`
        .global-textarea:enabled:focus {
          outline: 0;
          border-color: #3b82f6 !important;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
        }

        .global-textarea:enabled:hover {
          border-color: #3b82f6 !important;
        }

        .global-textarea:disabled {
          cursor: not-allowed;
          opacity: 0.6;
        }
      `}</style>
    </div>
  );
};